import React from "react";
import { Container } from "react-bootstrap";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  return (
    <>
      <section className="privacy_section">
        <Container>
          <div className="privacy_main">
            <div className="title_div mb-4">
              <h2 className="semi_title">Privacy Policy</h2>
            </div>
            <div className="mb-md-3 mb-3 ">
              <p className="text ">
                This privacy policy sets out how SG Transport uses and protects any
                information that you give SG Transport when you use this
                website/mobile application for Customers and Driver Partners.
                This Privacy Policy is an electronic record between you and
                SG Transport under the Information Technology Act, 2000 together with
                the Rules framed from time to time.
              </p>

              <p className="text ">
                Your privacy matters to SmartShift Logistics Solutions Private
                Limited (the <strong>"Company"</strong>, <strong>"we"</strong>,{" "}
                <strong>"SG Transport"</strong>, or <strong>"us"</strong>).
              </p>

              <p className="text ">
                This Privacy Policy (<strong>"Policy"</strong>) describes the
                policies and procedures on the collection, use, disclosure and
                protection of your information when you use our website located
                at
                <a href="mailto:sgtransportwala1@gmail.com">
                  <b> sgtransportwala1@gmail.com </b>
                </a>{" "}
                , or the SG Transport mobile applications named SG Transport and SG Transport
                Delivery Driver App (collectively,{" "}
                <strong>"SG Transport Apps"</strong>) and is applicable, without
                limitation, to those including customers/service recipients and
                drivers.
              </p>

              <p className="text ">
                The terms <strong>"you"</strong> and <strong>"your"</strong>{" "}
                refer to the user of the Porter Apps. The term{" "}
                <strong>"Services"</strong> refers to any services offered by
                Porter/You whether on the Porter Apps or otherwise. This Policy
                is a part of and incorporated within, and is to be read along
                with, the applicable Terms of Service and the Driver Partner
                Terms and Conditions based on the user of Porter.
              </p>

              <p className="text ">
                Porter is committed to ensuring that your privacy is protected.
                Should we ask you to provide certain information by which you
                can be identified when using this website, then you can be
                assured that it will only be used in accordance with this
                privacy statement.
              </p>

              <p className="text ">
                By using the Porter Apps and the Services, you agree and consent
                to the collection, transfer, use, storage, disclosure and
                sharing of your information as described and collected by us in
                accordance with this Policy. If you do not agree with the
                Policy, please do not use or access the Porter Apps.
              </p>

              <p className="text ">
                Porter may change this policy from time to time by updating this
                page. The current version of this policy is effective from 9th
                March, 2023. You should check this page from time to time to
                ensure that you are happy with any changes. The first version of
                this policy was effective from 23rd February 2014, which can be
                accessed here. The second version of this policy was effective
                from 11th November, 2022, which can be accessed here.
              </p>
            </div>
            <div>
              <p className="sub_title">WHAT WE COLLECT</p>
              <p className="text mb-md-3 mb-3">
                We may collect the following information:
              </p>
              <ul>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">Name and job title.</p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    Contact information including email address.
                  </p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    Demographic information such as postcode, address, mobile
                    number, login name, preferences and interests.
                  </p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    When you use our Services, we may collect and store
                    information about you to process your requests and
                    automatically complete forms for future transactions,
                    including (but not limited to) your phone number, address,
                    email, billing information, invoices, etc.
                  </p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    Other information relevant to customer surveys and/or
                    offers.
                  </p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    App install, uninstall and other installed apps information.
                  </p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    If you sign up to use our Services as a Driver Partner, we
                    may collect location details, profile picture, copies of
                    government identification documents and other details (KYC),
                    vehicle related documents such as insurance, pollution
                    certificate, bank account details, utility bills,
                    registration certificate, driving license, etc. and such
                    other documents which evidence the health or fitness of the
                    vehicle to provide Services on the SG Transport Apps, call and SMS
                    details which may be shared with our customer while
                    providing the Services.
                  </p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    We collect background check and identity verification
                    information of the Driver Partner. This may include
                    information such as driver history or criminal record (where
                    permitted by law), and right to work. This information may
                    be collected by an authorized vendor on the Company’s
                    behalf.
                  </p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    In case you sign up as a Driver Partner, enable features
                    that require SG Transport’s access to other applications on your
                    device aiming to prevent frauds towards the customers. In
                    case the Driver Partner wishes to participate in the
                    referral program, the contact list stored in the phone will
                    be accessed by us post the Driver Partner consents to share
                    such selected mobile number. We do not intend to share such
                    selected mobile numbers with any third party.
                  </p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    You may request when you would like to review the
                    information you have provided and SG Transport shall ensure that
                    any personal information or sensitive personal data or
                    information found to be inaccurate or deficient shall be
                    corrected or amended as feasible.
                  </p>
                </li>
                <li className="text mb-3">
                  <p className="text mb-md-3 mb-3">
                    SG Transport shall not retain sensitive personal data or
                    information for longer than is required for the purposes for
                    which the information may lawfully be used.
                  </p>
                </li>
              </ul>
              <p className="sub_title">
                WHAT WE DO WITH THE INFORMATION WE GATHER
              </p>
              <p className="text mb-3">
                We require this information to understand your needs and provide
                you with a better service, and in particular for the following
                reasons:
              </p>
              <ul>
                <li className="text mb-3">
                  <b>Internal Record Keeping</b>
                </li>
                <p className="text mb-3">
                  We may use the information to improve our Services. We may use
                  this information to:
                </p>
                <ol className="mb-3">
                  <li className="text mb-3">
                    Allow you to use Services on the SG Transport Apps and to carry
                    out our obligations arising from any contracts between you
                    and us
                  </li>
                  <li className="text mb-3">
                    Allow you to undertake or initiate any transactions on the
                    SG Transport Apps
                  </li>
                  <li className="text mb-3">
                    To inform your usage of the SG Transport Apps and to manage your
                    account with SG Transport Apps
                  </li>
                  <li className="text mb-3">
                    To process the payments with respect to the transactions
                    which you may avail on the SG Transport Apps and to perform
                    ancillary Services
                  </li>
                  <li className="text mb-3">
                    To respond to your comments, reviews, and questions, in
                    order to provide customer support and better Services
                  </li>
                  <li className="text mb-3">
                    To communicate important notices and changes to the Services
                    provided on the SG Transport Apps
                  </li>
                  <li className="text mb-3">
                    To track the order status, processing, and delivery of
                    Services as per your applicability
                  </li>
                  <li className="text mb-3">
                    For any other purposes with your consent
                  </li>
                </ol>
                <p className="text mb-2">
                  We may periodically send promotional emails, SMSs and make
                  voice calls about new products, special offers or other
                  information which we think you may find interesting using the
                  email address and mobile number which you have provided.
                </p>
                <p className="text mb-3">
                  From time to time, we may also use your information to contact
                  you for market research purposes. We may contact you by email,
                  SMS, voice, fax or mail. We may use the information to
                  customize the website according to your interests.
                </p>
                <p className="text mb-3">
                  You may specifically opt-out of the above in accordance with
                  the Telecom Commercial Communications Customer Preference
                  Regulations, 2018 or otherwise specified. In case you wish to
                  opt out of the same, please contact us at 4410 4410 (add your
                  city code).
                </p>
                <li className="text mb-3">
                  <b>Security</b>
                </li>
                <p className="text mb-3">
                  We are committed to ensuring that your information is secure.
                  In order to prevent unauthorized access or disclosure we have
                  put in place suitable physical, electronic and managerial
                  procedures in accordance with the Information Technology
                  (Reasonable security practices and procedures and sensitive
                  personal data or information) Rules, 2011 (
                  <strong>"IT RSP Rules"</strong>) to safeguard and secure the
                  information we collect online. We do not retain any
                  information collected from you for any longer than is
                  reasonably required by us for the purpose of our Services or
                  such period as may be required by applicable laws in India.
                  You are required to keep your information and all the other
                  data you obtain on the SG Transport Apps strictly confidential.
                </p>
                <li className="text mb-3">
                  <b>Disclosure</b>
                </li>
                <p className="text mb-3">
                  We may disclose to third party services certain personally
                  identifiable information listed below:
                </p>
                <ol className="mb-3">
                  <li className="text mb-3">
                    Information you provide us such as name, email, mobile phone
                    number, language.
                  </li>
                  <li className="text mb-3">
                    Information we collect as you access and use our service,
                    including device information, location, and network carrier.
                    We collect precise or approximate location data in the
                    foreground when the SG Transport Apps from the users’ mobile
                    devices if they enable us to do so. SG Transport collects this
                    data from the time a ride or delivery is requested until it
                    is finished, and any time the app is running in the
                    foreground of their mobile device. We use this data to
                    enhance your use of our apps, including to improve pick-up
                    locations, enable safety features, and prevent and detect
                    fraud. SG Transport collects the Driver Partner’s location data,
                    and links location data collected during a trip with their
                    customer’s account, even if the customer has not enabled us
                    to collect location data from their device. This enables us
                    to offer Services to the customers like receipt generation
                    and customer support.
                  </li>
                </ol>
                <p className="text mb-3">
                  This information is shared with third party service providers
                  under contracts entered into with them so that we can:
                </p>
                <ol className="mb-3">
                  <li className="text mb-3">
                    Personalize the SG Transport Apps for you so you get the smoothest
                    experience.
                  </li>
                  <li className="text mb-3">Perform behavioural analytics.</li>
                  <li className="text mb-3">
                    Sharing of information with our Vendors, Consultants,
                    Marketing Partners, Research Firms and other Service
                    Providers or Business Partners such as payment processing
                    entities, to support our Services.
                  </li>
                  <li className="text mb-3">
                    We may share your information with our academic partners for
                    the purposes of carrying out academic research.
                  </li>
                  <li className="text mb-3">
                    In case if you are a Driver Partner with{" "}
                    <strong>SG Transport</strong>, we may share your name, phone
                    number and/or profile picture (if applicable) with other
                    users in order to provide them the Services.
                  </li>
                  <li className="text mb-3">
                    We may disclose this information with the Governmental
                    Agencies, enforcement agencies or other companies assisting
                    us, when we are obligated under applicable laws or in good
                    faith or in compliance to any orders or processes; or
                    detecting and preventing against actual or potential
                    occurrence of identity theft, fraud, abuse of Services and
                    other illegal acts.
                  </li>
                </ol>
              </ul>
              <p className="sub_title">PROHIBITED ACTIVITIES</p>
              <p className="text mb-3">
                As per Rule 3(1)(b) of the Information Technology (Intermediary
                Guidelines and Digital Media Ethics Code) Rules, 2021, you shall
                not host, display, upload, modify, publish, transmit, store,
                update or share any information that:
              </p>
              <ol className="mb-3">
                <li className="text mb-3">
                  Belongs to another person and to which the user does not have
                  any right.
                </li>
                <li className="text mb-3">
                  Is defamatory, obscene, pornographic, paedophilic, invasive of
                  another’s privacy, including bodily privacy, insulting or
                  harassing on the basis of gender, libellous, racially or
                  ethnically objectionable, related to or encouraging money
                  laundering or gambling, or otherwise inconsistent with or
                  contrary to the laws in force.
                </li>
                <li className="text mb-3">Is harmful to children.</li>
                <li className="text mb-3">
                  Infringes any patent, trademark, copyright, or other
                  proprietary rights.
                </li>
                <li className="text mb-3">
                  Violates any law for the time being in force.
                </li>
                <li className="text mb-3">
                  Deceives or misleads the addressee about the origin of the
                  message or knowingly and intentionally communicates any
                  information which is patently false or misleading in nature
                  but may reasonably be perceived as a fact.
                </li>
                <li className="text mb-3">Impersonates another person.</li>
                <li className="text mb-3">
                  Threatens the unity, integrity, defence, security or
                  sovereignty of India, friendly relations with foreign states,
                  public order, causes incitement to the commission of any
                  cognizable offence, prevents investigation of any offence, or
                  insults another nation.
                </li>
                <li className="text mb-3">
                  Contains software viruses or any other computer code, file, or
                  program designed to interrupt, destroy, or limit the
                  functionality of any computer resource.
                </li>
                <li className="text mb-3">
                  Is patently false and untrue, written or published in any
                  form, with the intent to mislead or harass a person, entity,
                  or agency for financial gain or to cause injury to any person.
                </li>
                <li className="text mb-3">
                  Personalize the SG Transport Apps for you so you get the smoothest
                  experience.
                </li>
                <li className="text mb-3">Perform behavioural analytics.</li>
                <li className="text mb-3">
                  Sharing of information with our vendors, consultants,
                  marketing partners, research firms, and other service
                  providers or business partners such as payment processing
                  entities, to support our services.
                </li>
                <li className="text mb-3">
                  We may share your information with our academic partners for
                  the purposes of carrying out academic research.
                </li>
                <li className="text mb-3">
                  In case you are a Driver Partner with <strong>SG Transport</strong>,
                  we may share your name, phone number, and/or profile picture
                  (if applicable) with other users in order to provide them the
                  services.
                </li>
                <li className="text mb-3">
                  We may disclose this information with governmental agencies,
                  enforcement agencies, or other companies assisting us, when we
                  are obligated under applicable laws or in good faith, or in
                  compliance with any orders or processes; or detecting and
                  preventing actual or potential occurrences of identity theft,
                  fraud, abuse of services, and other illegal acts.
                </li>
              </ol>
              <p className="text mb-3">
                In case of with non-compliance with rules and regulations,
                Policy or the terms of service, we have the right to terminate
                the access or usage rights of the users to the computer resource
                or the SG Transport Apps immediately or remove non-compliant
                information or both, as the case may be.
              </p>
              <p className="sub_title">WITHDRAWAL OR NON-PROVISION OF DATA</p>
              <p className="text mb-3">
                Please note that You shall have an option not to provide the
                data or information sought to be collected. You shall, at any
                time while availing the Services or otherwise, also have an
                option to withdraw its consent given earlier to SG Transport by
                contacting us. Such withdrawal of the consent shall be sent in
                writing to the body corporate. However, in such cases, SG Transport
                shall have the option not to provide any Services for which the
                said information was sought.
              </p>
              <p className="sub_title">HOW WE USE COOKIES</p>
              <p className="text mb-3">
                A cookie is a small file which asks permission to be placed on
                your computer's hard drive. Once you agree, the file is added
                and the cookie helps analyze web traffic or lets you know when
                you visit a particular site. Cookies allow web applications to
                respond to you as an individual. The web application can tailor
                its operations to your needs, likes and dislikes by gathering
                and remembering information about your preferences.
              </p>{" "}
              <p className="text mb-3">
                We use traffic log cookies to identify which pages are being
                used. This helps us analyze data about webpage traffic and
                improve our website in order to tailor it to customer needs. We
                only use this information for statistical analysis purposes and
                then the data is removed from the system.
              </p>{" "}
              <p className="text mb-3">
                Overall, cookies help us provide you with a better website, by
                enabling us to monitor which pages you find useful and which you
                do not. A cookie in no way gives us access to your computer or
                any information about you, other than the data you choose to
                share with us.
              </p>{" "}
              <p className="text mb-3">
                You can choose to accept or decline cookies. Most web browsers
                automatically accept cookies, but you can usually modify your
                browser setting to decline cookies if you prefer. This may
                prevent you from taking full advantage of the website and/or
                SG Transport Apps.
              </p>
              <p className="sub_title">LINK TO OTHER WEBSITES</p>
              <p className="text mb-3">
                Our website may contain links to other websites of interest.
                However, once you have used these links to leave our site, you
                should note that we do not have any control over that other
                website which may also be in form of a banner advertisement. We
                do not sell, share, rent or trade the information we have
                collected about you, other than as disclosed within this Privacy
                Policy or at the time you provide your information. Therefore,
                we cannot be responsible for the protection and privacy of any
                information which you provide whilst visiting such sites and
                such sites are not governed by this privacy statement. You
                should exercise caution and look at the privacy statement
                applicable to the website in question and may contact that third
                party directly.
              </p>{" "}
              <p className="text mb-3">
                We will not disclose or share your personal information to third
                parties unless we have your permission or are required by law to
                do so. We may use your personal information to send you
                promotional information about third parties which we think you
                may find interesting if you tell us that you wish this to happen
              </p>{" "}
              <p className="text mb-3">
                You may request details of personal information which we hold
                about you under the Information Technology (Reasonable security
                practices and procedures and sensitive personal data or
                information) Rules, 2011. If you would like a copy of the
                information held on you please contact us.
              </p>{" "}
              <p className="text mb-3">
                If you believe that any information we are holding on you is
                incorrect or incomplete, please write to or email us as soon as
                possible, at the above address. We will promptly correct any
                information found to be incorrect.
              </p>
              <p className="sub_title">CONTACT US</p>
              <p className="text mb-3">
                If there are any questions regarding this privacy policy or if
                you wish to report a breach of the Privacy Policy, you may
                contact us using the information on the support page.
              </p>{" "}
              <p className="sub_title">GRIEVANCE OFFICER</p>
              <p className="text mb-3">
                In accordance with the Information Technology Act, 2000
                (including amendments there to) and rules made there under, the
                Contact details of the Grievance Officer are provided below, if
                you have queries or concerns regarding this privacy policy only,
                you may reach out directly in the following details:
              </p>{" "}
              <p className="text mb-3">Legal Team,</p>{" "}
              <p className="text mb-3">
                SR NO 73, INDIRA NAGAR, NEAR NEW TRANSFORMER, DIGHI, Pune,
                Maharashtra, 411015
              </p>{" "}
              <p className="text mb-3">Email Id: sgtransportwala1@gmail.com</p>{" "}
              <p className="text mb-3">
                Time: Monday to Friday (10 a.m. to 6 p.m.)
              </p>{" "}
              <p className="text mb-3">
                For any queries or concerns regarding our Services, kindly email
                us at sgtransportwala1@gmail.com.
              </p>{" "}
            </div>
          </div>
        </Container>
        <div className="privacy_overlay"></div>
      </section>
    </>
  );
}

export default PrivacyPolicy;
